module.exports = __webpack_public_path__ + "media/images/icons/sort_hover_asc-57761133a824ffc0ab05fd53460e2fb4.png";